import React, { forwardRef, useContext, useImperativeHandle } from "react";
import "./index.scss";
import { MyContext } from "../../contexts/ContextProvider";

const inputType = "outlined";

let EditCurrencyForm = ({ data }, ref) => {
  const [code, setCode] = React.useState("");

  const [name, setName] = React.useState("");
  const { currencyCode } = useContext(MyContext)

  useImperativeHandle(
    ref,
    () => {
      return {
        getValues: () => ({
          code,
          name,
        }),
        clearVals: () => {
          setCode("");
          setName("");
        },
      };
    },
    [code, name]
  );

  React.useEffect(() => {
    if (data) {
      setCode(data.code ?? "");
      setName(data.name ?? "");
    }
  }, [data]);

  return (
    <div>
      <div className="edit_form __line __fist">
        <select
          name="code"
          id={`code`}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="__form-input bg-[#f2f8fb]"
        >
          <option value="">Select a Currency Code</option>
          {currencyCode?.map((item, index) => (
            <option key={index} value={item?.code}>
              {item?.code}
            </option>
          ))}
        </select>
        <select
          name="name"
          id={`name`}
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="__form-input bg-[#f2f8fb]"
        >
          <option value="">Select a Currency Name</option>
          {currencyCode?.map((item, index) => (
            <option key={index} value={item?.name}>
              {item?.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default forwardRef(EditCurrencyForm);
